import React from 'react';
import { Facebook, ExternalLink } from 'lucide-react';
import { useSocial } from '../contexts/SocialContext';

/**
 * Embedded Facebook Page Plugin showing latest posts of the official page.
 * Falls back to a plain link when no page is configured.
 */
export const FacebookFeed = () => {
  const { social } = useSocial();
  const pageUrl = social?.facebookUrl;
  if (!pageUrl) return null;

  const iframeSrc =
    `https://www.facebook.com/plugins/page.php?` +
    `href=${encodeURIComponent(pageUrl)}` +
    `&tabs=timeline&width=380&height=420&small_header=true` +
    `&adapt_container_width=true&hide_cover=true&show_facepile=true`;

  return (
    <section className="bg-gradient-to-b from-black via-[#0a0a0a] to-black py-14 border-t border-[#C4A55A]/10" id="social">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
          {/* Text column */}
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#C4A55A] mb-3">
              <Facebook className="h-3.5 w-3.5" /> Bleiben Sie auf dem Laufenden
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 leading-tight">
              Folgen Sie uns auf <span className="text-[#C4A55A]">Facebook</span>
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 max-w-md">
              Aktuelle Bauprojekte, Marktanalysen und Insider-News aus dem Schweizer
              Immobilienmarkt — direkt aus dem Hause Löwenherz Invest AG.
            </p>
            <a
              href={pageUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fb-page-cta"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1877F2] hover:bg-[#1660c8] text-white text-sm font-semibold transition-colors"
            >
              <Facebook className="h-4 w-4" /> Seite besuchen
              <ExternalLink className="h-3.5 w-3.5 opacity-70" />
            </a>
          </div>

          {/* Embed column */}
          <div className="bg-white rounded-xl overflow-hidden shadow-2xl border border-[#C4A55A]/20 mx-auto w-full max-w-[380px]">
            <iframe
              title="Löwenherz Invest AG auf Facebook"
              src={iframeSrc}
              width="380"
              height="420"
              style={{ border: 'none', overflow: 'hidden', display: 'block', width: '100%' }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              data-testid="fb-page-embed"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
